import { MotionStyle } from "framer-motion"

export type Overflow = "visible" | "hidden" | "scroll" | "auto"

export interface OverflowProperties {
    overflow: Overflow
}

export function collectOverflowFromProps(props: Partial<OverflowProperties>, style: MotionStyle) {
    if (props.overflow) {
        style.overflow = props.overflow
    }
}
